import type { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Body1 } from '@myphx-engineering/phx-design-system';

import {
    useFillPathway,
    useFillPrescription,
} from '../../../../contexts/fill/use-fill-prescription';
import { CoverageStatus } from '../../../../graphql/generated/graphql';

export const InsuranceCoverageNotice = () => {
    const { t } = useTranslation('lilly');
    const { coverage } = useFillPrescription();
    const { originalPathway } = useFillPathway();

    let bodyText: ReactNode = '';

    if (coverage === CoverageStatus.NotCovered) {
        bodyText = (
            <Trans
                t={t}
                i18nKey="fill.coverage.notCovered"
                components={{ 1: <strong /> }}
            />
        );
    }

    if (coverage === CoverageStatus.Unknown && originalPathway !== 'fallback') {
        bodyText = (
            <Trans
                t={t}
                i18nKey="fill.coverage.unknown"
                components={{ 1: <strong /> }}
            />
        );
    }

    if (!bodyText) {
        return null;
    }

    return <Body1>{bodyText}</Body1>;
};
